GameObject = require './gameObject'

class RifleMan extends GameObject
  constructor: (x, y, gridHelper) ->
    super x, y, gridHelper

    @moveSpeed = 3

    @images = @createImages [
        "rifleman_left.png",
        "rifleman_left2.png",
        "rifleman_right.png",
        "rifleman_right2.png",
        "rifleman_turn.png"
      ]

    @drawable = @images[4]
    @drawable.x = @x
    @drawable.y = @y

  update: (player) =>
    @findPath this, player, (path) =>
      return if !path.targetX?
      if path.targetX > path.x
        @x += @moveSpeed
      else if path.targetX < path.x
        @x -= @moveSpeed
      if path.targetY > path.y
        @y += @moveSpeed
      else if path.targetY < path.y
        @y -= @moveSpeed

    super player

module.exports = RifleMan
